<div
  class="badge"
  [style.background-color]="backgroundColor()"
>
  <span>{{ label() }}</span>
</div>
